module.exports = __webpack_public_path__ + "img/d80fdbb.png";